export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_12-9aa105c19d0a05928edde4de84779132.jpg";